import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  coverImage: string;
  excerpt: string;
  date: string;
  readTime: string;
  views: string;
}

export default function ArticleCard({ slug, title, category, coverImage, excerpt, date, readTime, views }: ArticleCardProps) {
  const catInfo = categories.find(c => c.slug === category);

  return (
    <Link
      to={`/article/${slug}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 no-underline cursor-pointer"
    >
      <div className="relative w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-2 mb-2">
            {catInfo && (
              <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                {catInfo.name}
              </span>
            )}
            <span className="text-xs text-foreground-500">{date}</span>
          </div>
          <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2 font-heading">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
            {excerpt}
          </p>
        </div>
        <div className="flex items-center gap-4 text-xs text-foreground-400 mt-2">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views}
          </span>
        </div>
      </div>
    </Link>
  );
}